import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { BreakdownRowSchema, ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** The Dashboard's Safety section, trust half (D12) — a summary, per N2/the trust query's rule. */
export const TrustStatsSchema = z
  .object({
    window: StatsWindowSchema,
    raised: ComparableCountSchema,
    confirmed: z.number().int().nonnegative(),
    dismissed: z.number().int().nonnegative(),
    bySignalType: z.array(BreakdownRowSchema),
  })
  .strict();

export type TrustStats = z.infer<typeof TrustStatsSchema>;
